module.exports = __webpack_public_path__ + "media/images/pokerroom/lotos/step3-96b0c9f38a9eebad4d2f48fcc4ad950c.jpg";